import script from "./HotReply.vue?vue&type=script&setup=true&lang=js"
export * from "./HotReply.vue?vue&type=script&setup=true&lang=js"

import "./HotReply.vue?vue&type=style&index=0&id=40eb90ce&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40eb90ce"]])

export default __exports__